import type { Assign } from '@ark-ui/react'
import {
  PasswordInput as ArkPasswordInput,
  usePasswordInput,
} from '@ark-ui/react/password-input'

import { useEnhancedChildren } from '~/hooks/use-enhanced-children'

import { cn } from '~/utils/cn'
import type { VariantProps } from '~/utils/tv'

import { root as rootStyles } from './input-password.styles'

export type InputPasswordSharedProps = Omit<
  VariantProps<typeof rootStyles>,
  'isDisabled' | 'isReadOnly' | 'isError'
>

export type InputPasswordRootProps = Assign<
  React.ComponentProps<typeof ArkPasswordInput.Root>,
  InputPasswordSharedProps
> & {
  readOnly: boolean
}

export function InputPasswordRoot({
  children,
  size,
  asChild,
  disabled,
  readOnly,
  invalid,
  onVisibilityChange,
  ...props
}: InputPasswordRootProps) {
  const passwordInput = usePasswordInput({
    disabled,
    invalid,
    onVisibilityChange,
  })

  const enhancedChildrenWithInjectProps = useEnhancedChildren(children, {
    targets: [
      'InputPasswordInput',
      'InputPasswordLabel',
      'InputPasswordHelperText',
    ],
    props: {
      size,
      readOnly,
    },
    asChild,
  })

  return (
    <ArkPasswordInput.RootProvider
      {...props}
      className={cn(
        rootStyles({
          size,
        })
      )}
      value={passwordInput}
    >
      {enhancedChildrenWithInjectProps}
    </ArkPasswordInput.RootProvider>
  )
}

InputPasswordRoot.displayName = 'InputPasswordRoot'
